/**
 * Device model API: discovered hosts of an IP range, adding them as devices, and an
 * Enterprise organization's extra devices (Platform Admin). Served by the Worker.
 */
import apiClient from './client';
import { createScan } from './scans';
import type { Asset } from '@/types/asset';
import type { DeviceUsageInfo, DiscoveredHosts, AddHostsResult } from '@/types/device';

export async function getDiscoveredHosts(rangeId: string): Promise<DiscoveredHosts> {
  const { data } = await apiClient.get<DiscoveredHosts>(`/devices/ranges/${rangeId}/hosts`);
  return data;
}

export async function addDiscoveredHosts(rangeId: string, hostIds: string[]): Promise<AddHostsResult> {
  const { data } = await apiClient.post<AddHostsResult>(`/devices/ranges/${rangeId}/hosts`, { host_ids: hostIds });
  return data;
}

/** A discovery scan: the range's live hosts only, through the cloud scanner or an agent. Uses one scan. */
export function startDiscovery(range: Asset, agentId?: string) {
  return createScan({ name: `Discover ${range.label ?? range.value}`, scan_type: 'discovery', target_asset_ids: [range.id], ...(agentId ? { agent_id: agentId } : {}) });
}

export async function setExtraDevices(orgId: string, extraDevices: number): Promise<DeviceUsageInfo> {
  const { data } = await apiClient.patch<DeviceUsageInfo>(`/devices/organizations/${orgId}`, { extra_devices: extraDevices });
  return data;
}
